import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-pattern"></div>
      <div className="container">
        <div className="cta-section">
          <div className="section-label">Ready to Transform Your Risk Analysis?</div>
          <h2 className="cta-title">See Our Platform in Action</h2>
          <p className="cta-description">Discover how our graph-based credit scoring can revolutionize your financial decision-making process.</p>
          <div className="footer-buttons">
            <Link to="/contact?demo=true" className="cta-button-link">
              <button className="cta-button">Schedule a Demo</button>
            </Link>
            <Link to="/contact" className="cta-button-link">
              <button className="cta-button">Contact Sales</button>
            </Link>
          </div>
        </div>
        
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">Mycelo</div>
            <p className="footer-tagline">Modern risk analysis powered by graph intelligence.</p>
          </div>
          
          <div className="footer-section">
            <h3 className="footer-heading">Industries</h3>
            <ul className="footer-links">
              <li><Link to="/industries">View All Industries</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3 className="footer-heading">Company</h3>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/solution">Solutions</Link></li>
              <li><Link to="/api">API</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3 className="footer-heading">Resources</h3>
            <ul className="footer-links">
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="copyright">© {currentYear} Mycelo. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;